module.exports = __webpack_public_path__ + "media/applicants/wsj-06dfc2f5.jpg";